/**
 * Push notification click target.
 * Routes LP owners to /orders and delivery staff to /delivery-staff/orders.
 */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import {
  getStaffSession,
  hasVendorSession,
  staffAppPath,
} from '../lib/deliveryStaffApi';

export default function OpenOrderAlert() {
  const navigate = useNavigate();

  useEffect(() => {
    const staff = getStaffSession();
    if (staff.token) {
      navigate(staffAppPath('/delivery-staff/orders'), { replace: true });
      return;
    }
    if (hasVendorSession()) {
      navigate('/orders', { replace: true });
      return;
    }
    const preferStaff =
      localStorage.getItem('delivery_staff_last_role') === 'staff';
    navigate(
      preferStaff ? staffAppPath('/delivery-staff/login') : '/login',
      { replace: true }
    );
  }, [navigate]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.5,
        bgcolor: '#f3f7f6',
      }}
    >
      <CircularProgress size={36} sx={{ color: '#0f766e' }} />
      <Typography variant="body2" color="text.secondary">
        Opening orders…
      </Typography>
    </Box>
  );
}
